import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {PatchAuthRequest, PatchAuthRequestParams} from 'domain/usecases';

export class RemotePatchAuthRequest implements PatchAuthRequest {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<void>,
	) {}

	async patch(params?: PatchAuthRequestParams): Promise<void> {
		const {signal, ...restParams} = params || {};

		const httpResponse = await this.httpClient.request({
			url: this.url,
			body: restParams,
			method: 'patch',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
